import EPGContainer from './src/index.web';
import Icon from './src/components/Icon';

export default EPGContainer;
export { Icon };
